import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Pages/components/Schedule.tsx
import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import icons from "../../utils/Icons";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import Spinner from "../../components/Spinner";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
var localizer = momentLocalizer(moment);
var BbPilots = function () {
    var chaseListNavigate = useChaseListNavigate();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var BackHandle = function () {
        chaseListNavigate("/");
    };
    var handleIframeLoad = function () {
        setLoading(false);
    };
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Schedule" }), _jsx("div", { className: "p-4", children: _jsxs("button", { onClick: function () { return BackHandle(); }, className: "flex items-center justify-start border bg-white border-slate-300 rounded-lg py-2 px-[13px]", children: [_jsx("img", { src: icons.leftChevron, alt: "left-arrow" }), _jsx("span", { className: "ml-3", children: "Back to chase list" })] }) }), loading ? (_jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) })) : null, _jsx("div", { className: "p-4", style: { display: loading ? "none" : "block" }, children: _jsx("iframe", { src: "https://bbpilots.com/", width: "100%", height: "600px", title: "BB Pilots", frameBorder: "0", onLoad: handleIframeLoad }) })] }));
};
export default BbPilots;
